import React from 'react';
import { FileCheck2 } from 'lucide-react';
import { toast } from 'react-toastify';
import { CustomModal } from '../../../../common/CustomModal';
import { SignaturePad } from '../../../../common/SignaturePad';
import i18n from '../../../../../i18n';
import { submitDeliveryCompletionApproval } from '../../AuctionApproval/services/auctionApprovalServices';

export class DeliveryCompletionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_loading: false,
      error: '',
    };
    this.sigPadRef = React.createRef();
  }

  handleClose = () => {
    if (this.sigPadRef.current) {
      this.sigPadRef.current.clear();
    }
    this.setState({ error: '', is_loading: false });
    this.props.onClose();
  };

  handleSubmit = async () => {
    const signature = this.sigPadRef.current && this.sigPadRef.current.getSignature();
    if (!signature) {
      this.setState({ error: i18n.t('signature_required') || 'Please provide a signature before submitting.' });
      return;
    }

    this.setState({ is_loading: true, error: '' });
    try {
      const response = await submitDeliveryCompletionApproval(this.props.auction.id, { signature });
      if (response.success) {
        toast.success(response.message || i18n.t('delivery_completed') || 'Delivery completion approved.');
        this.props.onSuccess && this.props.onSuccess();
        this.handleClose();
      } else {
        this.setState({ error: response.message || 'Something went wrong.', is_loading: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ error: 'Something went wrong.', is_loading: false });
    }
  };

  renderFooter() {
    const { is_loading } = this.state;
    return (
      <div className="header-action">
        <button className="button1 button1-gray" onClick={this.handleClose} disabled={is_loading}>
          {i18n.t('cancel') || 'Cancel'}
        </button>
        <button className="button1 button1-primary" onClick={this.handleSubmit} disabled={is_loading}>
          {is_loading ? (i18n.t('submitting') || 'Submitting...') : (i18n.t('confirm_and_sign') || 'Confirm & Sign')}
        </button>
      </div>
    );
  }

  render() {
    const { show } = this.props;
    const { error } = this.state;
    return (
      <CustomModal
        isOpen={show}
        onClose={this.handleClose}
        header={i18n.t('delivery_completion_approval') || 'Delivery Completion Approval'}
        headerIcon={<FileCheck2 size={18} />}
        footer={this.renderFooter()}
        modalClassName="delivery-approval-modal"
      >
        <div className="wam-form-section">
          <p className="dam-instructions">
            {i18n.t('operator_completion_instructions') ||
              'Confirm that this item has been physically delivered / collected. Sign below to close out this delivery.'}
          </p>
          <SignaturePad ref={this.sigPadRef} />
          {error ? <p className="dam-error-text">{error}</p> : null}
        </div>
      </CustomModal>
    );
  }
}
